module.exports = __webpack_public_path__ + "img/banner.9ed68fe1.jpg";